import { API_BASE_URL as BASE_URL } from '../config';

const API_BASE_URL = `${BASE_URL}/notify`;

// Helper function to get authorization headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('auth_token');
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  return headers;
};

// POST /punte/bulk - create multiple punte for a team's marksheet submission
export async function notifyBulkPunte(bulkData) {
    const response = await fetch(`${API_BASE_URL}/punte/bulk`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(bulkData)
    });
  
    if (!response.ok) {
      throw new Error("Kon nie punte skep nie");
    }
  
    return await response.json();
  }